export default __webpack_public_path__ + "static/media/halls-4.b0487216.webp";